module.exports = __webpack_public_path__ + "img/6.747c47ad.jpg";